import { baseurl, LogErrorMessage, post } from '../service';

function assertSelfServeLambdaBaseUrl(base) {
  const lower = String(base || '').toLowerCase();
  if (
    lower.includes('update-next') ||
    lower.includes('update-alpha') ||
    lower.includes('update-v2')
  ) {
    throw new Error(
      'SELF_SERVE_LAMBDA_BASE_URL must be API Gateway /selfserve, not HGPRO Next portal URL',
    );
  }
}

/**
 * Records server-side campaign intent (modal CTA or promoSeries landing).
 * @param {{ userId: string, campaignId: string }} payload
 */
export const recordCampaignIntent = async ({ userId, campaignId }) => {
  const apiBase = baseurl();
  assertSelfServeLambdaBaseUrl(apiBase);
  const url = `${apiBase}/campaign-intent`;
  return post(
    url,
    {
      userId,
      campaignId,
    },
    '2.0',
  );
};

export async function trySyncCampaignIntent(userId, campaignId) {
  if (!userId?.trim() || !campaignId?.trim()) {
    return false;
  }

  try {
    await recordCampaignIntent({
      userId: userId.trim(),
      campaignId: campaignId.trim(),
    });
    return true;
  } catch (error) {
    LogErrorMessage(error);
    return false;
  }
}
